import { Space } from "antd";
import { EntityLabel } from "components/Shared/Labels/EntityLabel";
import { RosterAndStaffButton } from "components/Shared/RosterAndStaffButton";
import { useSharedColumnBuilder } from "hooks/useSharedColumnBuilder";
import { useIntl } from "react-intl";
import { Link } from "react-router-dom";
import { ColorIndicator } from "../../../../components/Shared/ColorIndicator.tsx";
import { DeleteTaskButton } from "../components/DeleteTaskButton";

export const useAdminFixturesColumns = () => {
  const { formatMessage } = useIntl();
  const {
    createCompetitionNameColumn,
    createSeasonNameColumn,
    createTaskStatusColumn,
    createFixtureRoundColumn,
    createFixtureVenueColumn,
    createFixtureStageColumn,
    createFixturePoolColumn,
    createFixtureSeriesColumn,
    createFixtureStartDateColumn,
    createFixtureStartTimeColumn,
    createIsRegistrationOpen,
  } = useSharedColumnBuilder();

  return [
    createCompetitionNameColumn(),
    createSeasonNameColumn("seasonNameLocal"),
    {
      title: formatMessage({ id: "columns.fixture.entityName" }),
      dataIndex: "taskEntityId",
      width: 300,
      render: (taskEntityId: any, record: any) => {
        return record?.homeEntity?.entityId === taskEntityId ? (
          <Space size="small">
            <ColorIndicator color={record?.homeEntity?.uniformTopItemColors?.primary} />
            <EntityLabel title={record?.homeEntity?.nameLocal} imageUrl={record?.homeEntity?.imageLogoUrl} />
          </Space>
        ) : (
          <Space size="small">
            <ColorIndicator color={record?.awayEntity?.uniformTopItemColors?.primary} />
            <EntityLabel title={record?.awayEntity?.nameLocal} imageUrl={record?.awayEntity?.imageLogoUrl} />
          </Space>
        );
      },
    },
    {
      title: formatMessage({ id: "columns.fixture.oppositeEntityName" }),
      dataIndex: "taskEntityId",
      width: 300,
      render: (taskEntityId: any, record: any) => {
        return record?.homeEntity?.entityId !== taskEntityId ? (
          <Space size="small">
            <ColorIndicator color={record?.homeEntity?.uniformTopItemColors?.primary} />
            <EntityLabel title={record?.homeEntity?.nameLocal} imageUrl={record?.homeEntity?.imageLogoUrl} />
          </Space>
        ) : (
          <Space size="small">
            <ColorIndicator color={record?.awayEntity?.uniformTopItemColors?.primary} />
            <EntityLabel title={record?.awayEntity?.nameLocal} imageUrl={record?.awayEntity?.imageLogoUrl} />
          </Space>
        );
      },
    },
    createFixtureRoundColumn(),
    createFixtureVenueColumn(),
    createFixtureStartDateColumn(),
    createFixtureStartTimeColumn(),
    createFixtureStageColumn(),
    createFixturePoolColumn(),
    createFixtureSeriesColumn(),
    createIsRegistrationOpen(),
    createTaskStatusColumn(),
    {
      align: "right",
      render: (_: any, record: any) => (
        <Space>
          <Link to={`entities/${record.taskEntityId}/seasons/${record.seasonId}/fixtures/${record.fixtureId}`}>
            <RosterAndStaffButton />
          </Link>
          <DeleteTaskButton entityId={record.taskEntityId} seasonId={record.seasonId} fixtureId={record.fixtureId} />
        </Space>
      ),
      width: 250,
    },
  ];
};
